import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
`;

export default Wrapper;
